import {
  getIndividualAttendeeInconvenienceText,
  GetIndividualAttendeeInconvenienceTextAttendanceImpact,
} from "@clockwise/client-commons/src/util/scheduling-slot";
import { NotInterested } from "@clockwise/design-system/icons";
import { AttendeesPains } from "@clockwise/web-commons/src/components/attendees-pains/AttendeesPains";
import { isEmpty } from "lodash";
import React from "react";
import { EventSchedulingQueryImpact, EventSchedulingQueryPerson } from "./EventScheduling";

type ConstructConflictMessageImpact = Pick<EventSchedulingQueryImpact, "conflictingMeetings">;
export type ConstructConflictMessagePerson = Pick<EventSchedulingQueryPerson, "isYou">;
export const constructConflictMessage = ({
  impacts,
}: {
  impacts: ConstructConflictMessageImpact;
}) => {
  let conflictString = "Conflict";
  if (impacts?.conflictingMeetings?.length) {
    if (impacts.conflictingMeetings.length === 1) {
      conflictString = `Conflict with ${impacts.conflictingMeetings[0]}`;
    } else {
      conflictString = `Conflict with ${impacts.conflictingMeetings.length} meetings`;
    }
  }

  return conflictString;
};

export type PainPointsImpacts = ConstructConflictMessageImpact &
  GetIndividualAttendeeInconvenienceTextAttendanceImpact &
  Pick<EventSchedulingQueryImpact, "hasConflict" | "unavailabilities">;
export type PainPointsPerson = ConstructConflictMessagePerson;
export const PainPoints = ({ impacts }: { impacts: PainPointsImpacts }) => {
  const pains = getIndividualAttendeeInconvenienceText(impacts);
  return (
    <React.Fragment>
      {impacts.hasConflict && (
        <div className="cw-whitespace-normal cw-flex cw-items-start cw-caption cw-text-warning cw-mb-2 last:cw-mb-0 ">
          <NotInterested className="cw-h-4 cw-w-4 cw-mr-1" />
          {constructConflictMessage({
            impacts,
          })}
        </div>
      )}
      {!isEmpty(impacts.unavailabilities) && (
        <div className="cw-whitespace-normal cw-flex cw-items-center cw-caption cw-text-warning cw-mb-2 last:cw-mb-0">
          <NotInterested className="cw-h-4 cw-w-4 cw-mr-1" />
          Unavailable
        </div>
      )}
      {pains.length > 0 && (
        <div className="cw-pt-1 cw-pr-1 cw-text-xs cw-text-muted">
          <AttendeesPains pains={pains} />
        </div>
      )}
    </React.Fragment>
  );
};
